var React = require('react');

function SpeakOn (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Unmute Icon"),React.createElement("g",{"stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},[React.createElement("path",{"d":"M12,4 L7,9 L3,9 C2.44771525,9 2,9.44771525 2,10 L2,14 C2,14.5522847 2.44771525,15 3,15 L7,15 L12,20 L12,4 Z","fill":"#FFFFFF","fillRule":"nonzero","key":0}),React.createElement("path",{"d":"M15,9 C16.5,10.5 16.5,13.5 15,15","stroke":"#FFFFFF","strokeWidth":"1.5","strokeLinecap":"round","key":1}),React.createElement("path",{"d":"M18,7 C20.5,9.5 20.5,14.5 18,17","stroke":"#FFFFFF","strokeWidth":"1.5","strokeLinecap":"round","key":2})])]);
}

SpeakOn.defaultProps = {"width":"24px","height":"24px","viewBox":"0 0 24 24","version":"1.1"};

module.exports = SpeakOn;

SpeakOn.default = SpeakOn;
